import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AddressService } from '../../../../../providers/services/address.service';
import { Subject} from 'rxjs';
import { AddAddressComponent } from '../add-address/add-address.component';
import { takeUntil } from 'rxjs/operators';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'pdp-address-book',
    templateUrl: './address-book.component.html',
    styleUrls: ['./address-book.component.scss'],
    imports: [NgFor, NgIf, RouterLink]
})
export class AddressBookComponent implements OnInit, OnDestroy {

  public addressResponse: any;

  @Input()
  public currentShippingAddress;

  @Input()
  public currentBillingAddress;

  @Input()
  public addressTypeChangeRequested: any;

  private unsubscribe: Subject<void> = new Subject();

  constructor(public addressService: AddressService) {
    this.addressResponse = this.addressService.addressResponse
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(e => {
      this.addressResponse = e;
    });
    this.addressService.updateAddresses();
  }

  ngOnInit() {}

  public useThisAddressForOrder(addressId) {
    const addressChangeRequest = {
      'addressId': addressId,
      'addressType': this.addressTypeChangeRequested.toUpperCase()
    };
    this.addressService.changeAddressForOrder(addressChangeRequest)
    .pipe(takeUntil(this.unsubscribe)).subscribe(status => {
      if (status === 200) {
        AddAddressComponent._orderUpdatedWithNewAddress.next('addressForOrderUpdated');
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
